function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.3547 8.28281C12.1422 7.4625 12.625 6.35391 12.625 5.13516V4.89609C12.625 2.37422 10.5602 0.328125 8.01484 0.328125H1.07969C0.725781 0.328125 0.4375 0.616406 0.4375 0.970312V16.8867C0.4375 17.2687 0.746875 17.5781 1.12891 17.5781H8.59844C11.3406 17.5781 13.5625 15.3703 13.5625 12.6445V12.3867C13.5625 10.6758 12.6859 9.16875 11.3547 8.28281ZM2.6875 2.57812H7.95391C9.29219 2.57812 10.375 3.61875 10.375 4.90547V5.12812C10.375 6.4125 9.28984 7.45547 7.95391 7.45547H2.6875V2.57812ZM11.2797 12.6422C11.2797 14.1164 10.068 15.3117 8.57266 15.3117H2.6875V9.71953H8.57266C10.068 9.71953 11.2797 10.9148 11.2797 12.3891V12.6422Z",
  fill: "currentColor"
});

var SvgIcBold = function SvgIcBold(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcBold, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_bold.90183230.svg";
export { ForwardRef as ReactComponent };